export default __webpack_public_path__ + "static/media/Enforcer's Boon.e7d8b73e.jpg";